import { render } from "./DepositComponent.vue?vue&type=template&id=7254bba4&scoped=true"
import script from "./DepositComponent.vue?vue&type=script&lang=js"
export * from "./DepositComponent.vue?vue&type=script&lang=js"

import "./DepositComponent.vue?vue&type=style&index=0&id=7254bba4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7254bba4"]])

export default __exports__